module.exports = __webpack_public_path__ + "static/media/button_playstore.207424e7.png";